import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitch from "../Languages/LanguageSwitch";
import { MenuContent } from "./MenuContent";
import DropdownMenu from "./DropdownMenu";
import ButtonBasic from "../Buttons/ButtonBasic";

function InlineMenu(
  props: Readonly<{
    menuContent?: MenuContent[];
  }>
) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="text-sm md:text-md flex">
      {props.menuContent?.map((menuContent) => {
        switch (menuContent.Type) {
          case "Route": {
            if (menuContent.Route?.IsMainRoute) {
              return (
                <ButtonBasic
                  key={menuContent.Route?.Name}
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate(menuContent.Route?.Route ?? "");
                  }}
                >
                  {t("Menu." + menuContent.Route?.Name)}
                </ButtonBasic>
              );
            } else {
              return (
                <DropdownMenu
                  key={"inline" + menuContent.Route?.Name}
                  buttonName={menuContent.Name}
                  setIsAllMenuOpen={setIsMenuOpen}
                  isAllMenuOpen={isMenuOpen}
                  isChildMenu={true}
                  isInline={true}
                  menuContent={menuContent.SubMenu}
                />
              );
            }
          }
          case "Language": {
            return (
              <LanguageSwitch
                key={"language"}
                setIsAllMenuOpen={setIsMenuOpen}
                isAllMenuOpen={isMenuOpen}
                languages={menuContent.Languages}
                isInline={true}
              />
            );
          }
          case "Link": {
            return <div key={menuContent.Name}></div>;
          }
          default: {
            return <div key={menuContent.Name}></div>;
          }
        }
      })}
    </div>
  );
}

export default InlineMenu;
